"use client";

import { useRouter } from "next/navigation";
import { DataTable, EmptyState } from "@/components/shared";
import type { PublisherTopSellerGame } from "../types";
import { publisherTopSellersColumns } from "../config";
import { PublisherTopSellerCards } from "./PublisherTopSellerCards";

interface PublisherTopSellersListProps {
  games: PublisherTopSellerGame[];
}

export function PublisherTopSellersList({
  games,
}: PublisherTopSellersListProps) {
  const router = useRouter();

  if (games.length === 0) {
    return <EmptyState message="No top sellers found for this publisher." />;
  }

  return (
    <div className="bg-[#16202d] rounded-lg border border-[#2a475e] overflow-hidden">
      <DataTable
        data={games}
        columns={publisherTopSellersColumns}
        getRowHref={(game) => `/app/${game.appid}`}
        getRowAriaLabel={(game) => game.name}
        getRowKey={(game) => game.appid}
      />
      <PublisherTopSellerCards
        games={games}
        onCardClick={(appid) => router.push(`/app/${appid}`)}
      />
    </div>
  );
}
